module.exports = __webpack_public_path__ + "static/media/quiz_background.67e4608a.svg";